import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonRoot } from 'trellis-components/components/Button/primitives';
import { CdpLink } from './CdpLink';
import { useUiVariant } from './UiVariantProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const TRELLIS_BUTTON_VARIANTS = {
  danger: 'primary-destructive',
  link: 'subtle-flush',
  primary: 'primary',
  secondary: 'normal',
  tertiary: 'normal',
  'tertiary-light': 'subtle',
  transparent: 'subtle'
};
export const TRELLIS_BUTTON_SIZES = {
  'extra-small': 'xs',
  xs: 'xs',
  small: 'sm',
  sm: 'sm',
  medium: 'md'
};
const TrellisCdpButton = ({
  'aria-label': ariaLabel,
  children,
  'data-selenium-test': dataSeleniumTest,
  'data-test-id': dataTestId,
  disabled,
  external,
  hideExternalLinkIcon,
  href,
  onClick,
  padding,
  paddingInlineStart,
  size,
  target,
  type,
  use = 'secondary'
}) => {
  const isFlush = use === 'transparent' && (padding === '0' || paddingInlineStart === '0');
  if (href) {
    return /*#__PURE__*/_jsx(CdpLink, {
      "aria-label": ariaLabel,
      "data-test-id": dataTestId,
      href: href,
      external: external,
      hideExternalLinkIcon: hideExternalLinkIcon || !external,
      target: target,
      disabled: disabled,
      onClick: onClick,
      children: children
    });
  }

  // TODO(trellis): Switch back to the config Button once it forwards data-*
  // attributes. It only passes data-test-id today, which drops the
  // data-selenium-test that selenium and acceptance tests target, so this
  // renders the ButtonRoot primitive, which passes HTML attributes through.
  const buttonProps = {
    variant: isFlush ? 'subtle-flush' : TRELLIS_BUTTON_VARIANTS[use],
    size: size ? TRELLIS_BUTTON_SIZES[size] : undefined,
    disabled,
    type,
    onClick,
    'data-test-id': dataTestId,
    'data-selenium-test': dataSeleniumTest
  };
  return ariaLabel ? /*#__PURE__*/_jsx(ButtonRoot, Object.assign({}, buttonProps, {
    "aria-label": ariaLabel,
    icon: children
  })) : /*#__PURE__*/_jsx(ButtonRoot, Object.assign({}, buttonProps, {
    children: children
  }));
};
export const CdpButton = props => {
  const variant = useUiVariant();
  return variant === 'trellis' ? /*#__PURE__*/_jsx(TrellisCdpButton, Object.assign({}, props)) : /*#__PURE__*/_jsx(Button, Object.assign({}, props));
};